import { IconButton } from 'components/Input/IconButton';
import SelectableTile from 'components/Input/SelectableTile';
import styled from 'styled-components';

export const StyledInformationWrapper = styled(SelectableTile)`
  height: 100%;
  padding: 0;
  border-radius: ${({ theme }) => theme.borderRadius['md']};
  box-sizing: border-box;
  display: flex;
  max-height: 10rem;
  margin-top: ${({ theme }) => theme.spacing['2Xl']};
  :hover {
    cursor: pointer;
  }
`;

export const StyledLeftContentWrapper = styled.div<{
  imageUrl: string;
}>`
  min-height: 100%;
  background-image: ${({ imageUrl }) => `url(${imageUrl})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  border-top-left-radius: ${({ theme }) => theme.borderRadius['md']};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius['md']};
  min-width: ${({ theme }) => theme.spacing['9Xl']};
`;

export const StyledRightContentWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing['xl']};
  width: 100%;
  display: flex;
  flex-direction: column;
  #information-content {
    margin-top: ${({ theme }) => theme.spacing['sm']};
    margin-bottom: ${({ theme }) => theme.spacing['md']};
    word-break: break-word;
  }
`;

export const StyledCTA = styled(IconButton)`
  align-self: flex-end;
`;
